<template>
  <div id="app">
    <Header></Header>
    <Tabs></Tabs>
    <EventGroupsList></EventGroupsList>
    <Cart></Cart>
    <Footer></Footer>
    <ErrorModal></ErrorModal>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Tabs from "@/components/Tabs";
import EventGroupsList from "@/components/EventGroupsList";
import Footer from "@/components/Footer";
import Cart from "@/components/Cart";
import ErrorModal from "@/components/ErrorModal";

export default {
  name: 'App',
  components: {
    ErrorModal,
    Tabs,
    Footer,
    Header,
    EventGroupsList,
    Cart
  }
}
</script>

<style lang="scss">
@import './assets/styles/custom.scss';
@import './assets/styles/fonts.scss';
@import '~bootstrap/scss/bootstrap.scss';
</style>
